







































































import { Component, Watch } from 'vue-property-decorator'
import { ListItem, MultiValue, OrderedListOptions } from '@/components/ui/DynamicTechTaskCard/types/input-field'
import AsyncValueMixin from '@/dynamic-tech-task/components/input/mixins/async-values'
import Draggable from 'vuedraggable'
import DynamicForm from '@/components/ui/DynamicTechTaskCard/DynamicForm.vue'


interface ListActionValue {
    action: 'add'|'remove'|'reorder';
    value: unknown;
    after: null|unknown;
}


interface OrderEvent {
    oldIndex: number;
    newIndex: number;
}


@Component({
    name: 'OrderedListField',
    components: {
        DynamicForm,
        Draggable
    }
})
export default class DropdownInputField extends AsyncValueMixin<OrderedListOptions, ListItem> {
    isAdding = false
    inputValue: string|null = null
    after: string|null = null

    @Watch('disabled')
    async resetOnEnable() {
        this.inputValue = null
        this.isAdding = false
        await this.loadOnEnable()
    }

    addValue() {
        this.$emit('input', {
            action: 'add',
            value: this.inputValue,
            after: null
        } as ListActionValue)
        this.$emit('submit')
        this.isAdding = false
    }

    removeValue(value: unknown) {
        this.$emit('input', {
            action: 'remove',
            value: value,
            after: null
        } as ListActionValue)
        this.$emit('submit')
        this.isAdding = false
    }

    onDrag(event: OrderEvent) {
        const value = this.inputValues[event.oldIndex].value
        const after = event.newIndex === 0 ? null : this.inputValues[event.newIndex].value
        this.$emit('input', {
            action: 'reorder',
            value: value,
            after: after
        } as ListActionValue)
        this.$emit('submit')
    }

    get afterValues(): MultiValue[] {
        const afterValues = []
        afterValues.push({
            display: 'First',
            value: null
        })
        afterValues.push(...this.inputValues)
        return afterValues
    }
}
